import React from 'react';
import { Card } from 'antd';
import { CompanySetupEnum, CompanySetUpTabHash } from 'enums/CompanySetupEnums';
import EmptyStateComponent from 'shared/components/EmptyStateComponent';
import useRedirect from 'shared/utils/useRedirect';
import styles from './company.module.scss';

const CompanyDashboardEmptyState: React.FC = () => {
  const { redirectToCompanySetUp } = useRedirect();

  return (
    <div className={styles.emptyStateContainer}>
      <div className={styles.organisationContainer}>
        <div>
          <div className={styles.dashboardHeading}>Dashboard</div>
          <Card>
            <div
              className={styles.parentOrgBox}
              onClick={redirectToCompanySetUp(CompanySetUpTabHash.LOCATIONS)}>
              <EmptyStateComponent
                title={CompanySetupEnum.AddParentOrgTitle}
                subHeading={CompanySetupEnum.CompanyDashboardEmptyStateTitle}
                subTitle={CompanySetupEnum.CompanyDashboardEmptyStateSubTitle}
              />
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CompanyDashboardEmptyState;
